import { render, staticRenderFns } from "./StudentPoster.vue?vue&type=template&id=41b9ceda&scoped=true&"
import script from "./StudentPoster.vue?vue&type=script&lang=js&"
export * from "./StudentPoster.vue?vue&type=script&lang=js&"
import style0 from "./StudentPoster.vue?vue&type=style&index=0&id=41b9ceda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b9ceda",
  null
  
)

export default component.exports